// components/MiceHighlights/MiceHighlights.jsx

import React, { useState } from "react";
import styles from "./MiceHighlights.module.css";

import HighlightCard, {
  clientData,
} from "./HighlightCard";

import HighlightList from "./HighlightList";

function MiceHighlights() {
  const [activeItem, setActiveItem] =
    useState(null);

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>
What we’ve accomplished
      </h2>

      <div className={styles.cardsGrid}>
        {clientData.map((item) => (
          <HighlightCard
            key={item.id}
            item={item}
            onClick={setActiveItem}
          />
        ))}
      </div>

      <HighlightList
        data={activeItem}
        isOpen={!!activeItem}
        onClose={() => setActiveItem(null)}
      />
    </section>
  );
}

export default MiceHighlights;